


const $c9fa5a8be4dbc78e$var$WINDOW_CHANGE_EVENT = 'onorientationchange' in window ? 'orientationchange' : 'resize';
document.querySelectorAll('.pure-toggle-menu').forEach((menu)=>{
    const toggle = menu.querySelector('.toggle');
    if (toggle == null) {
        console.warn("'.pure-toggle-menu' without '.toggle'");
        return;
    }
    const toggleMenu = ()=>{
        menu.classList.toggle('closed');
        toggle.classList.toggle('x');
    };
    toggle.addEventListener('click', (e)=>{
        e.preventDefault();
        toggleMenu();
    });
    window.addEventListener($c9fa5a8be4dbc78e$var$WINDOW_CHANGE_EVENT, ()=>{
        if (menu.classList.contains('closed')) return;
        toggleMenu();
    });
});





//# sourceMappingURL=Default.6170ef04.js.map
